import { createStateSyncMiddleware } from "redux-state-sync";
import {
	DELETE_STREAM_COMPLETE,
	DELETE_STREAM_MARKER_COMPLETE,
	SAVE_STREAM_COMPLETE,
	UPDATE_STREAM_MARKER_COMPLETE,
	SET_TIME_SKIP,
	TOGGLE_STREAM_OPEN,
	RESET_TIME_SKIP,
	SET_POPOUT_CLOSED,
	SET_POPOUT_OPEN,
	GET_STREAMS_COMPLETE
} from "../../state/stream/constants";
import { SELECT_EVENT_STREAM_COMPLETE } from "../../state/events/constants";

const stateSyncMiddleware = createStateSyncMiddleware({
	whitelist: [
		UPDATE_STREAM_MARKER_COMPLETE,
		DELETE_STREAM_MARKER_COMPLETE,
		SAVE_STREAM_COMPLETE,
		DELETE_STREAM_COMPLETE,
		SET_TIME_SKIP,
		RESET_TIME_SKIP,
		SELECT_EVENT_STREAM_COMPLETE,
		TOGGLE_STREAM_OPEN,
		SET_POPOUT_CLOSED,
		SET_POPOUT_OPEN,
		GET_STREAMS_COMPLETE
	]
});

/**
 * Utility function used to update redux state when the provided event ids are equivalent.
 * @param {string} eventId1
 * @param {string} eventId2
 * @param {Record<string, *>} state The original state
 * @param {Record<string, *>} matchState The state for when the event ids match.
 */
export const stateSyncEventMatch = (eventId1, eventId2, state, matchState) => {
	return eventId1 === eventId2 ? matchState : state;
};

export default stateSyncMiddleware;
